<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :base-info="baseInfo"
    resource="customers"
    :nameProps="{ edit: false, field: 'enterprise_name' }" />

</template>

<script>

export default {
  name: 'ChannelDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        {
          field: 'email',
          title: this.$t('scope.text_431'),
        },
        {
          field: 'user_name',
          title: this.$t('scope.text_322'),
        },
        {
          field: 'mobile',
          title: this.$t('scope.text_432'),
        },
        {
          field: 'memo',
          title: this.$t('scope.text_327'),
          showOverflow: 'ellipsis',
          width: '120px',
          slots: {
            default: ({ row, cellValue }, h) => {
              const ret = [<list-body-cell-wrap row={ row } field="memo" />]
              return ret
            },
          },
        },
      ],
    }
  },
}
</script>
